<template>
  <div class="shop-type">
    <div class="content" v-if="state != 0">
      <router-link
        class="item"
        v-for="(item, index) in storeList.shopList"
        :to="`/details?shopType=${shopType}&id=${index}`"
        :key="index"
      >
        <h3>{{ item.name }}</h3>
        <h4>{{ item.address }}</h4>
        <p :class="{ active: index == 0 }" v-if="isGeoFlag">
          <i class="iconfont icon-address"></i
          >{{ item.distance < 0 ? "未知" : `${item.distance}Km`
          }}{{ index == 0 && item.distance >= 0 ? "(距离最近)" : "" }}
        </p>
        <i class="iconfont icon-arrow arrow"></i>
      </router-link>
    </div>

    <div class="tip" v-if="state == 0">
      <!-- <img src="../../assets/img/tip.svg"/> -->
      <svg class="svg-tip" viewBox="0 0 1024 1024">
        <path
          d="M512 128c212 0 384 172 384 384s-172 384-384 384-384-172-384-384 172-384 384-384m0-64C264.8 64 64 264.8 64 512s200.8 448 448 448 448-200.8 448-448S759.2 64 512 64z"
          p-id="2078"
        ></path>
        <path d="M480 704h64v64h-64zM480 256h64v384h-64z" p-id="2079"></path>
      </svg>
      <span>暂无信息，您可选择附近其他城市或其他类型的体验店</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "shop-content",
  props: ["storeList", "state", "isGeoFlag", "shopType"],
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/global.scss";
.content {
  > .item {
    display: block;
    position: relative;
    background: #ffffff;
    padding: (16rem / $base) (24rem / $base);
    & + .item {
      border-top: (1rem / $base) solid #eee;
    }
    > h3 {
      font-size: (28rem / $base);
    }
    > h4,
    p {
      font-size: (24rem / $base);
      color: $color-text-b;
    }
    > h4 {
      margin-top: (8rem / $base);
      width: 90%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    > p {
      margin-top: (12rem / $base);
    }
    .active {
      color: $color-text-highlight;
    }
    > .arrow {
      position: absolute;
      right: (24rem / $base);
      top: 50%;
      transform: translateY(-50%);
    }
    .icon-address {
      vertical-align: middle;
      font-size: (18rem / $base);
      margin-right: (7rem / $base);
    }
  }
}
.tip {
  margin: 54rem / $base auto 0;
  overflow: hidden;
  box-sizing: border-box;
  width: 457rem / $base;
  font-size: (24rem / $base);
  $tip-color: rgba(
    $color: #bbb,
    $alpha: 0.7,
  );
  color: $tip-color;
  text-align: left;

  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;

  overflow: visible;
  > .svg-tip {
    display: inline-block;
    fill: $tip-color;
    height: 3em;
    margin-right: 0.5em;
  }
  > span {
    // display: inline-block;
  }
}
</style>
